<template>
    <b-standard-card
        :title="translations.title[lang]"
        :loading="loading"
        :error-message="errorMessage"
        :disabled="!vatIsValid"
        @submit="
            updateInvoicing({
                type: 'invoicing',
                item: invoicing,
            })
        "
        :submit-text="{ el: 'Αποθήκευση', en: 'Save', it: 'Salva' }"
    >
        <v-row no-gutters>
            <v-col cols="12" sm="6" class="pr-0 pr-sm-2">
                <b-text-field
                    v-model="invoicing.comp_name"
                    :label="translations.name[lang]"
                    no-top-margin
                ></b-text-field>
            </v-col>
            <v-col cols="12" sm="6" class="pl-0 pl-sm-2">
                <b-text-field
                    v-model="invoicing.vat_number"
                    :label="translations.taxId[lang]"
                    :success="vatIsValid"
                    :error-messages="vatError"
                    :disabled="!invoicing.country_id"
                    @focus="vatError = ''"
                    @blur="validateVatNumber"
                    no-top-margin
                ></b-text-field>
            </v-col>
            <v-col cols="12" sm="6" class="pr-0 pr-sm-2">
                <b-text-field
                    v-model="invoicing.city"
                    :label="translations.address[lang]"
                ></b-text-field>
            </v-col>
            <v-col cols="12" sm="6" class="pl-0 pl-sm-2">
                <b-text-field
                    v-model="invoicing.occupation"
                    :label="translations.profession[lang]"
                ></b-text-field>
            </v-col>
            <v-col cols="12" sm="6" class="pr-0 pr-sm-2">
                <b-text-field
                    v-model="invoicing.tax_office"
                    :label="translations.jurisdiction[lang]"
                ></b-text-field>
            </v-col>
            <v-col cols="12" sm="6" class="pl-0 pl-sm-2">
                <b-select
                    v-model="invoicing.country_id"
                    :items="countries"
                    :label="translations.invoice[lang]"
                    @change="validateVatNumber"
                ></b-select>
            </v-col>
        </v-row>
    </b-standard-card>
</template>

<script>
import { mapActions, mapMutations } from "vuex";
import translations from "@/utils/translations/storePanel/settings/profile/invoicing";

export default {
    name: "Invoicing",

    mixins: [translations],

    data: () => ({
        countries: [{ text: "Greece 24%", value: 1 }],
        invoicing: {},
        errorMessages: {
            vatNumberRequired: {
                el: "Απαιτείται Αριθμός ΑΦΜ",
                en: "Vat Number is required",
                it: "È richiesto il numero di partita IVA"
            },
            vatNumberLength: {
                el: "Ο Αριθμός ΑΦΜ πρέπει να έχει από 9 εώς χαρακτήρες",
                en: "Vat Number must be from 9 to 12characters long",
                it: "Il numero di partita IVA deve avere una lunghezza compresa tra 9 e 12 caratteri."
            },
        },
        vatIsValid: false,
        vatError: ''
    }),

    computed: {
        lang() {
            return this.$route.params.lang;
        },

        loading() {
            return this.$store.state.storePanel.profile.loading.invoicing;
        },

        errorMessage() {
            return this.$store.state.storePanel.profile.errorMessage.invoicing;
        },
    },

    methods: {
        ...mapActions(["checkVatNumber"]),
        ...mapActions("storePanel/profile", ["updateInvoicing"]),
        ...mapMutations("storePanel/profile", ["setErrorMessage"]),

        
        async validateVatNumber() {
            this.vatError = ''
            let isValid = false;
            if (!this.invoicing.vat_number) {
                this.vatError = ( this.errorMessages.vatNumberRequired[
                    this.lang
                ]);
                isValid = false;
            } else if (this.invoicing.vat_number.length < 9 || this.invoicing.vat_number.length > 12) {
                this.vatError = (this.errorMessages.vatNumberLength[
                    this.lang
                ]);
                isValid = false;
            } else if (this.invoicing.vat_number?.length >= 9) {
                let res = await this.checkVatNumber({afm:this.invoicing.vat_number, country_id: this.invoicing.country_id});
                if (res.data?.status === 'success') {
                    isValid = true;
                } else if (res.data?.error) {
                    this.vatError = (res.data?.message || "");
                    isValid = false;
                }
            }
            return isValid;
        },

        showError(value){
            this.setErrorMessage({
                value, type: "invoicing"
            })
        }
    },

    watch: {
        ["$store.state.storePanel.store"]: {
            immediate: true,
            handler(val) {
                this.invoicing = {
                    comp_name: val.billing_details ? val.billing_details.comp_name : "",

                    vat_number: val.billing_details ? val.billing_details.vat_number : "",

                    city: val.billing_details ? val.billing_details.city : "",

                    occupation: val.billing_details ? val.billing_details.occupation : "",

                    tax_office: val.billing_details ? val.billing_details.tax_office : "",

                    country_id: val.billing_details ? val.billing_details.country_id : null,
                };
            },
        },
        ["invoicing.vat_number"]: {
            immediate: true,
            async handler(val) {
                if (val?.length === 9) {
                    this.vatIsValid = await this.validateVatNumber();
                } else {
                    this.vatIsValid = false;
                }
            }
        },
    },
};
</script>
